<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="1000px"
    class="edit-part-num-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="content">
        <div class="item-title">{{i18n.page_content_part_msg}}</div>
        <el-form>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="i18n.label_part_class + '：'">{{ getDicValue('asm_part_class', info.partClass) || '-'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="i18n.label_part_type + '：'">{{ getDicValue('asm_part_type', info.partType) || '-'}}</el-form-item>
            </el-col>

           <el-col :span="8">
              <el-form-item :label="i18n.label_payment_org + '：'">{{getDicValue('asm_part_replace_payment_org', info.paymentOrg) || '-'}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
             <el-col :span="8">
              <el-form-item :label="i18n.label_part_code + '：'">{{info.partCode || '-'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="i18n.label_part_name + '：'">{{info.partName || '-'}}</el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item :label="i18n.label_part_spec + '：'">{{info.partSpec || '-'}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
             <el-col :span="8">
              <el-form-item :label="i18n.label_part_unit + '：'">{{info.partUnit || '-'}}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-form
          label-position="top"
          :model="info"
          :rules="rules"
          ref="form"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="i18n.label_componentName"
                prop="componentName"
              >
                <el-input
                  v-model="info.componentName"
                  :placeholder="i18n.placeholder_input_component_name"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="i18n.label_part_num"
                prop="replaceNum"
              >
                <el-input
                  v-model="info.replaceNum"
                  :min="1"
                  type="number"
                  :placeholder="i18n.placeholder_input_part_num"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{i18n.com_cancel}}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{i18n.com_confirm}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 * 编辑零件数量
 */
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      info: {},
    };
  },
  computed: {
    rules() {
      return {
        componentName: {
          required: true,
          message: this.$t('Common.com_required')
        },
        replaceNum: {
          required: true,
          message: this.$t('Common.com_required')
        },
      };
    }, },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$postJSON(
            apis.caseOrderPartSetNum,
            {
              orderPartId: this.model.data.orderPartId,
              replaceNum: this.info.replaceNum,
            },
            true
          ).then(() => {
            this.$message({
              message: this.i18n.com_handle_success,
              type: 'success',
            });
            this.$emit('success');
            this.closeDialog();
          });
        }
      });
    },
  },
  created() { },
  mounted() {
    this.info = {
      ...this.model.data,
    };
  },
};
</script>

<style lang="scss" scoped>
.edit-part-num-dialog {
  .dialog-body {
  }
}
</style>
